jQuery(document).ready(function($) {
    'use strict';

    function handleScrollInView() {
        // Do nothing if gallery is open
        if ($('body').hasClass('overflow-hidden')) {
            return;
        }

        $('.scroll-in-view').each(function() {
            const top_of_element = $(this).offset().top;
            const bottom_of_element = top_of_element + $(this).outerHeight();
            const bottom_of_screen = $(window).scrollTop() +
                $(window).innerHeight() -
                150;
            const top_of_screen = $(window).scrollTop();

            if (
                bottom_of_screen > top_of_element &&
                top_of_screen < bottom_of_element &&
                !$(this).hasClass('is-visible')
            ) {
                $(this).addClass('is-visible');
            }
        });
    }

    $(window).on('scroll', handleScrollInView);
    handleScrollInView();

    function closeGallery() {
        $('.timeline-gallery.is-open').removeClass('is-open');
        $('main').removeClass('has-open-gallery');
        $('body').removeClass('overflow-hidden');
    }

    $(document).on('click', '.timeline-open-gallery', function() {
        const $gallery = $(this).next('.timeline-gallery');
        const $images = $gallery.find('img');

        $images.removeClass('is-active');
        $images.first().addClass('is-active');

        $gallery.addClass('is-open');
        $('main').addClass('has-open-gallery');
        $('body').addClass('overflow-hidden');
    });

    $(document).on('click', '.timeline-close-gallery', function(e) {
        e.stopPropagation();
        closeGallery();
    });

    $(document).on('click', '.timeline-gallery', function() {
        closeGallery();
    });

    $(document).on('click', '.timeline-gallery > div', function(e) {
        e.stopPropagation();
    });

    $(document)
        .on('click', '.timeline-gallery button[title="Nästa"]', function(e) {
            e.stopPropagation();

            const $gallery = $(this).closest('.timeline-gallery');
            const $images = $gallery.find('img');
            const $active = $images.filter('.is-active');

            let index = $images.index($active);
            $active.removeClass('is-active');

            $images.eq((index + 1) % $images.length).addClass('is-active');
        });

    $(document)
        .on(
            'click',
            '.timeline-gallery button[title="Föregående"]',
            function(e) {
                e.stopPropagation();

                const $gallery = $(this).closest('.timeline-gallery');
                const $images = $gallery.find('img');
                const $active = $images.filter('.is-active');

                let index = $images.index($active);
                $active.removeClass('is-active');

                $images.eq((index - 1 + $images.length) % $images.length)
                    .addClass('is-active');
            },
        );

    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeGallery();
        }
    });

});

//* No scroll on timeline gallery open *//
jQuery(document).ready(function($) {
    'use strict';

    function closeGallery() {
        $('.timeline-gallery.is-open').removeClass('is-open');
        $('html').css('overflow', ''); // remove overflow:hidden
        $('.timeline-event').removeClass('gallery-open'); // ta bort klass
    }

    // Öppna galleri
    $(document).on('click', '.timeline-open-gallery', function() {
        const $gallery = $(this).next('.timeline-gallery');
        $gallery.addClass('is-open');
        $('html').css('overflow', 'hidden'); // stop scrolling
        $('.timeline-event').addClass('gallery-open'); // lägg till klass
    });

    // Klicka på galleri-bakgrund för att stänga
    $(document).on('click', '.timeline-gallery', function() {
        closeGallery();
    });

    // Klicka på själva innehållet ska inte stänga
    $(document).on('click', '.timeline-gallery > div', function(e) {
        e.stopPropagation();
    });

    // Klicka på stäng-knapp
    $(document).on('click', '.timeline-close-gallery', function(e) {
        e.stopPropagation();
        closeGallery();
    });

    // ESC-tangent för att stänga galleri
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape') {
            closeGallery();
        }
    });

});
